export default {
    title: "PRIVACY SETTING",
    mkt: "Marketing Message",
    copy_Data: "Copy Personal Data",
    tranfer_data: "Transfer Data",
    save_success_title: "บันทึกข้อมูลการรับข่าวสารสำเร็จ",
    save_success_msg: "คุณได้ทำการบันทึกการตั้งค่าข้อมูล </br> การรับข่าวสารเรียบร้อยแล้ว",

    mkt_setting: {
        title: "MARKETING POLICY ON USE <br />OF PERSONAL DATA",
    },
    copydata: {
        title: "Copy Personal Data",
        name: "Name",
        lastname: "Last Name",
        birthdate: "Birthday",
        phone: "Phone number",
        age: "Age",
        age_detail: "I certify that I am at least 20 years old",
        email_label: "กรอกอีเมลสำหรับรับข้อมูล",
        email: {
            name: 'กรอกอีเมลสำหรับรับข้อมูล',
            placeholder: '',
            required: 'Please enter your email',
            too_short: '',
            invalid: 'The email address is incorrect.',
        },
        password_label: "กำหนดรหัสผ่านในการเปิดไฟล์",
        confirm_export: "ยืนยันการขอรับสำเนาข้อมูลส่วนบุคคล",
        export_success_title: "ขอรับข้อมูลส่วนบุคคลสำเร็จ",
        export_success_detail: "ทำรายการการขอข้อมูลส่วนบุคคลสำเร็จ ระบบ </br> ได้จัดส่งข้อมูลส่วนบุคคลไปยังอีเมลเรียบร้อยแล้ว",

    },
    transferdata_title: 'Transfer Data',
    contact_callcenter: 'Other request please contact call center',
    contact_phone: '02-6451212',
}
